import React from 'react';

interface StarRatingProps {
  rating: number; // 1-5
  size?: 'small' | 'medium' | 'large';
}

function StarRating({ rating, size = 'medium' }: StarRatingProps) {
  const sizeClass = `stars-${size}`;

  return (
    <div className={`star-rating ${sizeClass}`} role="img" aria-label={`${rating} out of 5 stars`}>
      {[1, 2, 3, 4, 5].map((star) => (
        <span
          key={star}
          className={`star ${star <= rating ? 'star-filled' : 'star-empty'}`}
          aria-hidden="true"
        >
          ★
        </span>
      ))}
    </div>
  );
}

export default StarRating;
